export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите название ', trigger: 'blur' },
    ],
    slug: [
        { required: true, message: 'Пожалуйста, введите Слуг ', trigger: 'blur' },
    ],
};
